/**
 * Bộ layout nộp dự toán
 * NXHung 19.08.2024
 */
export default {
  /// Chi đầu tư
  INVEST: 1,
  /// Chi thường xuyên
  REGULAR: 2,
  /// Chi CTMT, mục tiêu khác
  PROJECT: 3,
  /// Chi khác
  EXPENSE_OTHER: 4,
  /// Thu NSNN
  REVENUE_BUDGET: 5,
  /// Thu Khác
  REVENUE_OTHER: 6,

};
